import React from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/DialogTitle';

import styles from './styles';

const InfoDialog = ({
  classes,
  isOpen,
  onClose,
  title,
  message,
  btnText,
}) => {
  

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="info-dialog-title"
      aria-describedby="info-dialog-description"
      PaperProps={{
        classes: {
          root: classes.dialogRoot,
        },
      }}
    >
      <DialogTitle
        id="info-dialog-title"
        classNames={classes.title}
      >
        {`${title}`}
      </DialogTitle>
      <DialogContent className={classes.content}>
        {message ? (
          <Typography variant="body1" className={classes.contentText}>
            {message}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          className={classes.button}
          disableTouchRipple
        >
          {btnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InfoDialog.propTypes = {
  classes: propTypes.object.isRequired,
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  title: propTypes.string.isRequired,
  message: propTypes.string,
  btnText: propTypes.string.isRequired,
};

export default withStyles(styles)(InfoDialog);
